<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control' :disabled='disabled'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const OZU = 'get_ozu.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'protectiveCatExt',
		data: function () { 
			return {
				selected: '',
				options: [],
				internal_id: null
			}
		},
		props: {
			line_count: 0,
			type: '',
			id: null,
			disabled: false
		},
		methods: {
			change () {
				EventBus.$emit(`${this.type}_protective_cat_ext`, {index: this.line_count, value: this.selected})
			},
			fill (id) {
				if(this.$parent.data_location.ozu.length)
				{
						
					this.options = this.$parent.data_location.ozu
					this.selected = (this.internal_id) ? this.internal_id : this.$parent.data_location.ozu[0].id
					this.internal_id = null
				} else {
					EventBus.$on('fetch_ozu_complete', () => {
						this.options = this.$parent.data_location.ozu
						this.selected = (this.internal_id) ? this.internal_id : this.$parent.data_location.ozu[0].id
						this.internal_id = null

						EventBus.$off('fetch_ozu_complete')
					})				
				}
			}
		},
		created: function () {
			this.internal_id = this.$props.id
			this.fill()
		},
		beforeDestroy () {
			EventBus.$off('fetch_ozu_complete')
			//EventBus.$off(`${this.type}_protective_cat_${this.line_count}`)
		}
	}
</script>


// WEBPACK FOOTER //
// protectiveCatExt.vue?2efcce30